<div class="list-card-body">

  @if (showCheckbox) {
  <div class="checkbox-container">
    <dxo-checkbox [value]="checkboxValue" (valueChange)="valueChangeFunction()" [disabled]="disabled">
    </dxo-checkbox>
  </div>
  }

  <div class="list-card-content">

    <div class="header-container">
      @if (title) {
      <div class="card-title">
        {{ title }}
      </div>
      }
      @if (statuses) {
      <div class="status-container">
        @for (status of statuses; track statusTrackByIndex($index, status)) {
        <dxo-status-indicator [text]="status.text" [color]="status.color" [icon]="status.icon!"
          [variant]="status.variant!" [matStyle]="status.matStyle!" [appendix]="status.appendix!" [link]="status.link!"
          [linkText]="status.linkText!">
        </dxo-status-indicator>
        }
      </div>
      }
    </div>

    <div class="content-container">
      <ng-content></ng-content>
      @if (bodyText) {
      <p class="body-text">
        {{ bodyText }}
      </p>
      }
      @if (labelValues.length) {
      <div class="label-values-container quad-even">
        @for (item of labelValues; track labelValueTrackByIndex($index, item)) {
        <dxo-label-value [currency]="item.currency!" [date]="item.date!" [percent]="item.percent!"
          [hiddenValue]="item.hiddenValue!" [href]="item.href!" [isError]="item.isError!" [isLink]="item.isLink!"
          [label]="item.label!" [largeFormat]="item.largeFormat!" [subValue]="item.subValue!"
          [tooltipContent]="item.tooltipContent!" [values]="item.values!">
        </dxo-label-value>
        }
      </div>
      }
      @if (buttons.length) {
      <div class="button-container">
        @for (button of buttons; track buttonTrackByIndex($index, button)) {
        <!-- Button with routerLink -->
        @if (button.routerLink && !button.href) {
        <dxo-button-v2 [label]="button.label" [variant]="button.variant || 'primary'" [size]="button.size || 'small'"
          [iconPosition]="button.iconPosition || 'right'" [matStyle]="button.matStyle || ''" [icon]="button.icon || ''"
          [routerLink]="button.routerLink" [queryParams]="button.queryParams" [destructive]="!!button.destructive"
          [download]="!!button.download" [newWindow]="!!button.newWindow" [allowReferer]="!!button.allowReferer"
          [setAutofocus]="!!button.setAutofocus" [disabled]="!!button.disabled" [loading]="!!button.loading"
          [type]="button.type || 'button'" (handleClick)="button.onClick?.()"></dxo-button-v2>
        }
        <!-- Button with href -->
        @if (button.href && !button.routerLink) {
        <dxo-button-v2 [label]="button.label" [variant]="button.variant || 'primary'" [size]="button.size || 'small'"
          [iconPosition]="button.iconPosition || 'right'" [matStyle]="button.matStyle || ''" [icon]="button.icon || ''"
          [href]="button.href" [queryParams]="button.queryParams" [destructive]="!!button.destructive"
          [download]="!!button.download" [newWindow]="!!button.newWindow" [allowReferer]="!!button.allowReferer"
          [setAutofocus]="!!button.setAutofocus" [disabled]="!!button.disabled" [loading]="!!button.loading"
          [type]="button.type || 'button'" (handleClick)="button.onClick?.()"></dxo-button-v2>
        }
        <!-- Regular button (no href or routerLink) -->
        @if (!button.href && !button.routerLink) {
        <dxo-button-v2 [label]="button.label" [variant]="button.variant || 'primary'" [size]="button.size || 'small'"
          [iconPosition]="button.iconPosition || 'right'" [matStyle]="button.matStyle || ''" [icon]="button.icon || ''"
          [queryParams]="button.queryParams" [destructive]="!!button.destructive" [download]="!!button.download"
          [newWindow]="!!button.newWindow" [allowReferer]="!!button.allowReferer" [setAutofocus]="!!button.setAutofocus"
          [disabled]="!!button.disabled" [loading]="!!button.loading" [type]="button.type || 'button'"
          (handleClick)="button.onClick?.()"></dxo-button-v2>
        }
        }
      </div>
      }
    </div>
  </div>
</div>